




































































































































import { Component, Watch, Vue } from 'vue-property-decorator'
import dayjs from 'dayjs'
import dayjsUTC from 'dayjs/plugin/utc'
import controller from '@/app/ui/controllers/ProgramaticPointController'
import { EventBus, EventBusConstants, Utils } from '@/app/infrastructures/misc'
import DateTimePicker from '@/app/ui/components/DateTimePicker/index.vue'
import DataTable from '@/app/ui/components/DataTable/index.vue'
import Button from '@/app/ui/components/Button/index.vue'
import TextInput from '@/app/ui/components/TextInput/index.vue'
import PaginationNav from '@/app/ui/components/PaginationNav/index.vue'
import DownloadIcon from '@/app/ui/assets/download_icon.vue'
import {
  PROGRAMMATIC_POINT_USAGE_PAGINATION
} from '@/app/infrastructures/misc/Constants'
import EmptyState from '@/app/ui/components/EmptyState/EmptyState.vue'
import Loading from '@/app/ui/components/Loading/index.vue'

interface Parameter {
  page: number
  perPage: number
  startDate: string | null
  endDate: string | null
  customerId: string | null
}

dayjs.extend(dayjsUTC)

@Component({
  components: {
    DateTimePicker,
    DataTable,
    DownloadIcon,
    PaginationNav,
    Button,
    TextInput,
    Loading,
    EmptyState,
  },
})
export default class UsagePoint extends Vue {
  controller = controller
  parameters: Parameter = {
    page: 1,
    perPage: PROGRAMMATIC_POINT_USAGE_PAGINATION,
    startDate: null,
    endDate: null,
    customerId: null,
  }
  headers = [
    'Program Name',
    'User ID',
    'Account Name',
    'Email',
    'City of Residence',
    'Get Point Date',
    'Expired Date',
    'Saldo Point',
    'Spending Point',
  ]

  created(): void {
    if (this.$route.query instanceof Object) {
      const queries = this.$route.query as Record<string, never>
      this.parameters = {
        page: Utils.alwaysNumber(queries.page) || 1,
        perPage:
          Utils.alwaysNumber(queries.perPage) ||
          PROGRAMMATIC_POINT_USAGE_PAGINATION,
        startDate: queries.startDate,
        endDate: queries.endDate,
        customerId: queries.customerId || null,
      }
    }

    EventBus.$on(
      EventBusConstants.DOWNLOAD_SALDO_USAGE_READY,
      (instance: { downloadUrl: string }) => {
        const link = document.createElement('a')
        link.href = instance.downloadUrl
        link.setAttribute('download', 'file.xlsx') //or any other extension
        document.body.appendChild(link)
        link.click()
        link.remove()
      }
    )

    controller.getProgramDetail(this.$route.params.id)
    this.fetchHistory()
  }

  get programName(): string | undefined {
    return controller.programDetail.name
  }

  get params(): Record<string, string | number | null> {
    return {
      ...this.parameters,
      startDate: this.parameters.startDate
        ? dayjs(this.parameters.startDate, 'YYYY-MM-DD')
            .utc()
            .toISOString()
        : null,
      endDate: this.parameters.endDate
        ? dayjs(this.parameters.endDate, 'YYYY-MM-DD')
            .endOf('days')
            .utc()
            .toISOString()
        : null,
    }
  }

  get historyData(): Array<unknown>[] {
    const data: Array<Array<unknown>> = []
    if (controller.historyData.length > 0) {
      // using FOR for better looping performance
      for (let i = 0; i < controller.historyData.length; i++) {
        data.push([
          controller.historyData[i].name,
          controller.historyData[i].userId,
          controller.historyData[i].userName,
          controller.historyData[i].userEmail,
          controller.historyData[i].city,
          dayjs(controller.historyData[i].getPointDate).format('DD/MM/YYYY'),
          dayjs(controller.historyData[i].expiredDate).format('DD/MM/YYYY'),
          `Rp ${Utils.currencyDigit(
            controller.historyData[i].saldoPoint || 0
          )}`,
          `Rp ${Utils.currencyDigit(
            controller.historyData[i].pointSpent || 0
          )}`,
        ])
      }
    }
    return data
  }

  @Watch('parameters', { deep: true })
  onParametersChanged(val: Record<string, never>): void {
    if (
      dayjs(val.endDate, 'YYYY-MM-DD').isBefore(
        dayjs(val.startDate, 'YYYY-MM-DD')
      ) ||
      !val.endDate
    ) {
      this.parameters.endDate = val.startDate
    }
  }

  @Watch('params')
  onParamsChanged(val: Record<string, never>): void {
    this.$router.push({
      query: {
        ...val,
        startDate: this.parameters.startDate
          ? dayjs(this.parameters.startDate).format('YYYY-MM-DD')
          : null,
        endDate: this.parameters.endDate
          ? dayjs(this.parameters.endDate).format('YYYY-MM-DD')
          : null,
      },
    })
  }

  private fetchHistory(resetPage?: boolean) {
    if (resetPage) {
      this.parameters.page = 1
    }

    controller.getProgramHistory({
      id: this.$route.params.id,
      params: this.params,
    })
  }

  private getExportUrl() {
    controller.getExportedFile({
      id: this.$route.params.id,
      params: this.params,
    })
  }

  beforeDestroy(): void {
    EventBus.$off(EventBusConstants.DOWNLOAD_SALDO_USAGE_READY)
  }
}
